<template>
  <div class="w-full bg-[#101116] u-center px-4 sm:px-0 sm:pb-16">
    <div class="mx-auto w-full max-w-[1100px]">
      <div class="text-white">
        <div class="flex flex-col sm:mt-12">
          <div class="text-24 leading-32 font-bold mb-3">Tarot hakkında daha fazla bilgi almak ister misin?</div>
          <div class="text-md leading-20 font-normal mb-6">2025 Seni Neler Bekliyor? Burç Yorumlarını Oku!</div>
          <div class="flex flex-col sm:flex-row sm:flex-wrap gap-4">
            <OLink
              v-for="(card, index) in tarotMoreInfoCards"
              :key="index"
              :href="card.url"
              class="flex-1 w-full h-[160px] flex p-6 gap-6 rounded-[20px] hover:opacity-95 transition-opacity duration-200 justify-between"
              :style="{ background: card.background }"
            >
              <div class="flex flex-col justify-between items-start">
                <h3 class="text-white text-24 leading-32 font-semibold line-clamp-2">{{ card.title }}</h3>
                <p class="text-white text-md font-medium flex items-center gap-1">
                  Oku
                  <OIcon icon="right-white" class="w-4 h-4" />
                </p>
              </div>

              <OImage :src="card.image" :alt="card.title" class="relative object-contain bottom-[-14px] w-[130px] h-[130px]" />
            </OLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { tarotMoreInfoCards } from '../utils/tarotUtils';
import { OLink, OImage, OIcon } from '~/modules/common/components/ui';
export default defineComponent({
  components: {
    OLink,
    OImage,
    OIcon,
  },
  setup() {
    return {
      tarotMoreInfoCards,
    };
  },
});
</script>

<style scoped>
.astrology-widget-card {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
